import React, {useEffect, useState} from 'react';
import {PageableTable} from "../../../components/DesignSystem/PageableTable/PageableTable";

const sorter = (a, b) => {

    if (typeof a === "number") return a - b;
    if (typeof a === "string") return a.localeCompare(b);
    if (a instanceof Date) return new Date(a) - new Date(b); // Date sorting
    return 0;

}

export const ExportPreviewTable = ({fetchData, columnNames, reloadData}) => {

    const [columns, setColumns] = React.useState([]);
    const [scrollY, setScrollY] = useState(650);

    useEffect(() => {

        if (!columnNames) {
            return;
        }

        setColumns(columnNames.map((item, index) => {
            return {
                title: item.name,
                dataIndex: item.name,
                key: index,
                sorter: (a, b) => sorter(a[item.name], b[item.name]),
                ellipsis: true,
                minWidth: 100,
                onCell: () => ({
                    style: {
                        whiteSpace: 'nowrap',
                        width: 'max-content',
                    },
                }),
            }
        }));

    }, [columnNames]);

    useEffect(() => {
        const updateHeight = () => {
            const headerOffset = 180; // adjust based on your layout
            const height = window.innerHeight - headerOffset;
            setScrollY(height);
        };

        updateHeight(); // set initial
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);


    return <PageableTable columns={columns}
                          reload={reloadData}
                          fetch={fetchData}
                          tableLayout="auto"
                          pagination={{
                              hideOnSinglePage: true,
                              pageSize: 10, // Set the number of rows per page
                              defaultCurrent: 1, // Default page to start on
                          }}
                          sticky={true} size={"small"} scroll={{ y: scrollY, x: 'max-content' }}/>;

}